import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import CulturePicker from "@/components/CulturePicker";
import { regionOfParcel } from "@/lib/cultures";
import { Label } from "@/components/ui/label";
import { createModification } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";


export const ModificationForm = ({ parcel, onClose, onSuccess }) => {
  const [description, setDescription] = useState("");
  const [suggestedCulture, setSuggestedCulture] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) {
      toast.error("Veuillez decrire la modification");
      return;
    }
    setSubmitting(true);
    try {
      await createModification({
        parcel_id: parcel.parcel_id,
        description: description.trim(),
        suggested_culture: suggestedCulture.trim() || null
      });
      onSuccess();
    } catch (err) {
      toast.error("Erreur lors de la soumission");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="modification-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Manrope, sans-serif', color: '#1A1A1A' }}>
            Demande de modification
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <p className="text-xs font-medium mb-1" style={{ color: '#4A4A4A' }}>Parcelle</p>
            <p className="text-sm font-semibold" style={{ color: '#1A1A1A' }}>
              {parcel.name} - {parcel.commune}
            </p>
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="description" className="text-xs font-medium" style={{ color: '#4A4A4A' }}>
              Description de la modification *
            </Label>
            <Textarea
              id="description"
              data-testid="mod-description"
              placeholder="Decrivez la correction necessaire (limites incorrectes, mauvaise culture identifiee, etc.)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="min-h-[100px] text-sm border-black/10"
            />
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs font-medium" style={{ color: '#4A4A4A' }}>
              Culture suggeree (optionnel)
            </Label>
            <CulturePicker value={suggestedCulture} onChange={setSuggestedCulture} region={parcel.region || regionOfParcel(parcel.parcel_id)}
              placeholder="Sélectionner une culture" testId="mod-culture-select" />
          </div>

          <div className="flex gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              className="flex-1 h-9 rounded-full text-xs border-black/10"
              onClick={onClose}
              data-testid="mod-cancel-btn"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              disabled={submitting}
              className="flex-1 h-9 rounded-full text-xs font-semibold"
              style={{ background: '#2D6A4F', color: 'white' }}
              data-testid="mod-submit-btn"
            >
              {submitting ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : null}
              {submitting ? "Envoi..." : "Soumettre"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ModificationForm;
